var map = {
	"./1/4.jpg": 8021,
	"./2/4.jpg": 3182,
	"./3/4.jpg": 8577,
	"./4/4.jpg": 9467,
	"./5/4.jpg": 8980,
	"./6/4.jpg": 7055,
	"./7/4.jpg": 3645,
	"./8/4.jpg": 2737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6741;